import i from"graphql-tag";import{CircleOnDemandFragmentDoc as s,CircleFacilitatorFragmentDoc as a}from"./fragments.generated.es.js";import*as t from"@apollo/react-hooks";const o={},r=i`
    query getOnDemandCircles($first: Int, $filterByLanguageCodes: [String!]) {
  circleOnDemandConnection(
    first: $first
    filterByLanguageCodes: $filterByLanguageCodes
  ) {
    ... on CircleOnDemandConnection {
      edges {
        node {
          ...CircleOnDemand
        }
      }
    }
  }
}
    ${s}
${a}`;function l(e){const n={...o,...e};return t.useQuery(r,n)}function m(e){const n={...o,...e};return t.useLazyQuery(r,n)}export{r as GetOnDemandCirclesDocument,m as useGetOnDemandCirclesLazyQuery,l as useGetOnDemandCirclesQuery};
//# sourceMappingURL=ondemand.generated.es.js.map
